import { render, staticRenderFns } from "./DetalheAtendimento.vue?vue&type=template&id=5ac70ba5&scoped=true&"
import script from "./DetalheAtendimento.vue?vue&type=script&lang=ts&"
export * from "./DetalheAtendimento.vue?vue&type=script&lang=ts&"
import style0 from "./DetalheAtendimento.vue?vue&type=style&index=0&id=5ac70ba5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac70ba5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VDivider,VRow,VTextField})
